import { navigate } from 'gatsby'

export const loginToDemoAccount = async () => {
  await fetch('/demo/auth')
  await navigate('/dashboard')
}
